function Footer() {
  return (
    <footer className="footer">
      <p className="footer__title">
        &copy; {new Date().getFullYear()} Yakov Bilbil
      </p>
    </footer>
  );
}

export default Footer;
